import TextField from "../components/TextField";
import ImageInput from "../components/ImageInput";
import {useEffect, useState} from "react";
import {useMutation} from "react-query";
import {requestOtp, sendDetails, verifyCard} from "../Api";
import OtpModal from "../components/OtpModal";
import {RiLoaderFill} from "react-icons/ri";
import {useAtom} from "jotai";
import {showBannerAtom} from '../App'
import ImageCropper from "../components/ImageCropper";
import {BsCheck2Circle} from "react-icons/bs";
import {IoWarningOutline} from "react-icons/io5";
import levenshtein from 'js-levenshtein'

const LinkCard = () => {
    const [frontImage, setFrontImage] = useState();
    const [backImage, setBackImage] = useState();
    const [selfie, setSelfie] = useState();
    const [accountNumber, setAccountNumber] = useState();
    const [cardNumberInvalid, setCardNumberInvalid] = useState(false)
    const [otp, setOtp] = useState("");
    const [cardNumber, setCardNumber] = useState("");
    const [showBanner, setShowBanner] = useAtom(showBannerAtom)
    const [showForm, setShowForm] = useState(false);
    const [imageVerificationMessage, setImageVerificationMessage] = useState("");
    const [canSubmit, setCanSubmit] = useState(false)
    const [percentage, setPercentage] = useState(0)

    const {
        data: verifyData,
        mutate: verify,
        isLoading,
        isError: verifyingError,
        error: verifyError
    } = useMutation(verifyCard);
    const {
        data: submitData,
        mutate: submit,
        isLoading: submitting,
    } = useMutation(sendDetails);
    const {data: otpData, mutate: getOtp, isLoading: gettingOtp} = useMutation(requestOtp);
    const [isModalShowing, setIsModalShowing] = useState(false);

    const handleAccountVerification = async () => {
        if (!accountNumber) return;
        await verify({AccountNumber: accountNumber});
    };

    const handleGetOTP = async() => {
        const {
            
                AccountDetails: {Phonenumber:Phonenumber, Email},
          
        } = verifyData;
        setIsModalShowing(true);
        await getOtp({Phonenumber, Email});
    };

   

    const handleSubmit = (e) => {
        e.preventDefault();
        if (cardNumber.length < 15) {
            setCardNumberInvalid(true)
            return
        }
        postData();

    };

    const postData = () => {
        if (!verifyData) return; 
        submit({
            Name: verifyData?.AccountDetails.CustomerName,
            AccountNumber: accountNumber,
            GhanaCardNumber: cardNumber,
            VerificationPercentage: percentage,
            BackImage: {
                base64: backImage?.base64,
                type: backImage?.type,
            },
            FrontImage: {
                base64: frontImage?.base64,
                type: frontImage?.type,
            },
        });
    };

    useEffect(() => {
        if (verifyData?.Status === "1") {
            handleGetOTP()
        }
    }, [verifyData?.Status])

    useEffect(() => {
        if (verifyData?.Status === "1") {
        }
    }, [submitData?.Status, verifyData?.Status])

 
useEffect(()=>{
    if(submitData?.Status==="1"){
        setIsModalShowing(true)
    }
},[submitData])
   

    useEffect(() => {
        if (otp !== otpData?.OTP) return;
        setShowBanner(false)
        setShowForm(true);
        setIsModalShowing(false)
    }, [otp, otpData?.OTP, setShowBanner]);

    useEffect(() => {
      
        if (!verifyData) return
      
        if (verifyData?.AccountDetails) {
            // setShowBanner(false)
        }
    }, [verifyData])

    useEffect(() => {
        if (imageVerificationMessage?.code === '00') {
            setCanSubmit(true)
        }
    }, [imageVerificationMessage])

    useEffect(() => {
     
        const accountName = verifyData?.AccountDetails?.CustomerName.toLowerCase()
        const accountDOB = verifyData?.AccountDetails?.DateOfBirth
        const ghanaCardName = imageVerificationMessage?.data?.person?.surname ? `${imageVerificationMessage?.data?.person?.surname} ${imageVerificationMessage?.data?.person?.forenames}`.toLowerCase() : null
        const cardDOB = imageVerificationMessage?.data?.person.birthDate
   

        if (accountName && ghanaCardName) {

          
            const similarity = levenshtein(accountName, ghanaCardName)
            
            const p = 100 - 100 * similarity / Math.max(accountName.length, ghanaCardName.length)
        
            const dobMatch = accountDOB === cardDOB
            setPercentage(p)

            if (p > 80 || (p < 80 && dobMatch === true)) {
                setCanSubmit(true)
            } else {
                setCanSubmit(false)
            }
        }
    }, [imageVerificationMessage?.data?.person?.forenames, imageVerificationMessage?.data?.person?.surname, verifyData?.AccountDetails?.CustomerName])

    return (
        <>
            <form onSubmit={handleSubmit} className="Form">
                {
                    // Alert to show image verification error
                    (imageVerificationMessage && imageVerificationMessage.code !== '00') && (
                        <div className="fixed inset-0 bg-black/30 p-4 flex items-center justify-center z-20">
                            <div
                                className='p-4 block w-full text-slate-800 bg-white rounded flex flex-col justify-center items-center max-w-xl'>
                                <IoWarningOutline className="text-red-600 h-16 w-16"/>
                                {imageVerificationMessage.code === '01' &&
                                    (<p className="p-3">Verification failed</p>)
                                }

                                {
                                    imageVerificationMessage.code === '02' && (
                                        <p className="p-3">{imageVerificationMessage.data}</p>)
                                }
                                <button className="p-1.5 text-white w-full bg-[#dd4f05] rounded"
                                        onClick={() => setImageVerificationMessage("")}> Ok
                                </button>
                            </div>
                        </div>
                    )
                }

                {
                    // Alert to show successful image verification
                    (imageVerificationMessage && imageVerificationMessage.code === '00') && (
                        <div className="fixed inset-0 bg-black/30 p-4 flex items-center justify-center z-20">
                            <div
                                className='p-4 block w-full text-slate-800 bg-white rounded flex flex-col justify-center items-center max-w-xl'>
                                <BsCheck2Circle className="text-green-600 h-16 w-16"/>
                                <p className="p-3">User photo verified successfully</p>
                                <button className="p-1.5 text-white w-full bg-[#dd4f05] rounded"
                                        onClick={() => setImageVerificationMessage("")}> Ok
                                </button>
                            </div>
                        </div>
                    )
                }


                <div className=" p-4 sm:p-2 flex flex-col space-y-4 ">
                    <div className="flex flex-col items-start w-full">
                        {/* Step 1 */}
                        <>
                            <TextField
                                label="Enter Account Number"
                                placeholder="eg: 201******110"
                                pattern="[0-9]+"
                                maxLength="14"
                                onChange={(e) => setAccountNumber(e.target.value)}
                                onBlur={handleAccountVerification}
                                required
                            />
                            {(isLoading || gettingOtp) && (
                                <span className="text-slate-600 mt-1.5 text-xs">Verifying account number ...</span>)}
                            {verifyingError &&
                                <span className="text-red-600 mt-1.5 text-xs"> An error occurred </span>}

                            {showForm && (
                                <span
                                    className="text-green-600 mt-1.5 text-xs">{verifyData.AccountDetails.CustomerName}</span>)}
                            {verifyData?.Status === "0" && (
                                <span className="text-red-600 mt-1.5 text-xs">{verifyData.Message}</span>)}
                        </>

                        {/* Step 2 */}
                        {showForm && (
                            <>
                                <div className="mt-2 w-full flex flex-col space-y-2">
                                    <div className="flex flex-col items-start">
                                        <TextField
                                            label="Enter Ghana Card Number"
                                            placeholder="***-********-*"
                                            value={cardNumber}
                                            onChange={(e) => {
                                                setCardNumber(e.target.value)
                                                setCardNumberInvalid(false)
                                            }}
                                            required
                                            maskedInput/>
                                        {cardNumberInvalid &&
                                            <span className="text-sm text-red-600">Invalid card number (eg: GHA-032233204-0)</span>}
                                        {!cardNumberInvalid &&
                                            <span className="text-sm text-slate-400">eg: GHA-032233204-0</span>}
                                    </div>

                                    {Boolean(cardNumber) && <ImageCropper ghanaCard={cardNumber}
                                                                          setImageVerificationMessage={setImageVerificationMessage}/>}

                                    <div className="flex flex-col items-start mt-4">
                                        <div
                                            className="flex flex-col space-y-4 sm:flex-row sm:space-y-0 sm:space-x-6 w-full">
                                            <ImageInput
                                                label="Front of card"
                                                onChange={(file) => setFrontImage(file)}
                                                required/>
                                            <ImageInput
                                                label="Back of card"
                                                onChange={(file) => setBackImage(file)}
                                                required/>
                                        </div>

                                        {/*{Boolean(cardNumber) && <ImageCropper ghanaCard={cardNumber}*/}
                                        {/*                                      setImageVerificationMessage={setImageVerificationMessage}/>}*/}
                                    </div>

                                </div>


                                <div className="w-full mt-4">
                                    <span className="text-slate-700 block text-start text-sm">
                                        Account & Card name match:
                                        <span
                                            className={percentage >= 60 ? ' text-green-600 font-medium' : 'text-red-600 font-medium'}> {percentage} %</span>
                                    </span>
                                    {percentage < 60 && (
                                        <span className="text-xs block text-start text-red-600"> You can not proceed because of account and card names mismatch or Birth dates mismatch </span>)}

                                    <button
                                       disabled={!canSubmit}
                                        type="submit"
                                        className={`text-base rounded-md border border-slate-200 p-2 w-full mt-4 ${canSubmit && percentage >= 60 ? 'bg-[#dd4f05]' : 'bg-[#dd4f05]/50'} text-white inline-flex justify-center`}>
                                        <span> Submit </span>
                                        {submitting && (<RiLoaderFill className="animate-spin h-5 w-5 ml-3"/>)}
                                    </button>
                                </div>
                            </>
                        )}

                        <div className="w-full mt-4">
                            {!showForm && (
                                <button
                                    type="button"
                                    onClick={handleAccountVerification}
                                    className="text-base rounded-md border border-slate-200 p-2 w-full mt-4 bg-[#dd4f05] text-white inline-flex justify-center">
                                    <span>Verify Account</span>
                                    {(isLoading || gettingOtp) && (
                                        <RiLoaderFill className="animate-spin h-5 w-5 ml-3"/>)}
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </form>

            {isModalShowing && (
                <OtpModal
                    toggleModal={() => setIsModalShowing(false)}
                    visible={isModalShowing}
                    setOtp={setOtp}
                    accountDetails={verifyData?.data}
                    getOtp={handleGetOTP}
                    isSubmitting={submitting}
                    submitResponse={submitData}/>
            )}
        </>
    );
};

export default LinkCard;
